<template>
  <section class="container">
    <quill-editor
      v-model="html"
      @change="handlerTextPage"/>
  </section>
</template>

<script>
import QuillEditor from '@/components/quill-editor1';
import Mixins from '@/mixins/operations'

export default {
  data() {
    return {
      html: '<p>测试</p>',
    };
  },
  mixins: [Mixins],
  components: {
    QuillEditor,
  },

  methods: {
  },

  watch: {
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/vuepage/example/editor.vue